import { useCallback, useEffect, useState } from 'react';

import { getCommunications } from 'modules/communications/redux/communicationActions';
import { store } from 'redux/store';

type UseGetCommunicationsProps = {
  societyId?: string;
  page?: number;
  rowsPerPage?: number;
};

export const useGetCommunications = ({
  societyId,
  page = 1,
  rowsPerPage = 10,
}: UseGetCommunicationsProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchCommunications = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getCommunications({
            societyId,
            params: {
              page,
              items: rowsPerPage,
            },
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [page, rowsPerPage, societyId]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchCommunications(controller);

    return () => controller.abort();
  }, [fetchCommunications]);

  return {
    isLoading,
    isError,
  };
};
